export enum CustomerDecisionTypeEnum {
  EXTEND_LOAN = "EXTEND_PAYROLL_LOAN",
  NEW_LOAN = "NEW_PAYROLL_LOAN",
}
